import { VoyageOverviewScreen } from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';
import { officeVoyageSource } from '../voyage-source.js';

/** Sefer özeti ve listesi (ortak ekran; ADR 0022). Ofis seferi planlar ve düzenler. */
export function VoyageListPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('voyage.overview.title')}>
      <VoyageOverviewScreen source={officeVoyageSource} />
    </Shell>
  );
}
